<template>
  <div class="user-table-container">
    <!-- Action Bar -->
    <v-card-title>
      <v-layout row align-center justify-space-between>
        <v-flex xs10 md9>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search staff members..."
            outline
            clearable
            hide-details
            class="search-field"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 md3 class="text-xs-right">
          <v-btn
            color="primary"
            @click="dialog = true"
            class="add-user-btn"
            style="color: black"
            :icon="$vuetify.breakpoint.xs"
          >
            <v-icon :class="{ 'mr-2': !$vuetify.breakpoint.xs }" color="black"
              >add</v-icon
            >
            <span v-if="!$vuetify.breakpoint.xs">Add Staff Member</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-title>

    <v-divider></v-divider>

    <!-- Data Table -->
    <v-data-table
      :headers="headers"
      :search="search"
      :loading="loadingMessage"
      :items="filterdUserData"
      :pagination.sync="pagination"
      class="modern-table"
    >
      <template slot="items" slot-scope="props">
        <tr v-if="props.item.user_role != 6" class="table-row">
          <td class="text-xs-left py-3">
            <v-chip small color="grey lighten-3" class="country-code">
              {{ props.item.user_country_tel }}
            </v-chip>
          </td>
          <td class="text-xs-left py-3">
            <div class="font-weight-medium">{{ props.item.user_tel }}</div>
          </td>
          <td class="text-xs-left py-3">
            <div class="font-weight-medium">{{ props.item.user_email }}</div>
          </td>
          <td class="text-xs-left py-3">
            <div class="font-weight-medium">
              {{ nameCheck(props.item) }}
            </div>
          </td>
          <td class="text-xs-center py-3">
            <v-chip
              small
              :color="getRoleColor(props.item.user_role)"
              text-color="white"
              class="role-chip"
            >
              {{ roleCheck(props.item) }}
            </v-chip>
          </td>
          <td class="text-xs-center py-3">
            <v-chip
              small
              :color="getTypeColor(props.item.user_type)"
              :text-color="getTypeTextColor(props.item.user_type)"
              class="type-badge-enhanced"
              v-if="typeCheck(props.item)"
            >
              {{ typeCheck(props.item) }}
            </v-chip>
            <span v-else class="no-type-text">-</span>
          </td>
          <td class="text-xs-center py-3">
            <v-btn
              small
              depressed
              :color="getAddressButtonColor()"
              :loading="fetching_address == props.item.user_id"
              @click="editAddress(props.item)"
              class="address-btn-modern"
            >
              <v-icon small class="mr-1">location_on</v-icon>
              View
            </v-btn>
          </td>
          <td class="text-xs-left py-3">
            <v-checkbox-otp
              otpTel="974563956"
              :isAlreadyCheck="alreadyCheckOTP"
              v-model="props.item.user_vip"
              @change="setVIP($event, props.item)"
              class="vip-checkbox"
            />
          </td>
          <td class="text-xs-center py-3">
            <div v-if="indexEditLoading != props.index" class="action-buttons">
              <v-tooltip top>
                <v-btn
                  icon
                  small
                  color="primary"
                  :disabled="isEditStaff"
                  @click="editItem(props.item)"
                  slot="activator"
                  class="mr-1"
                >
                  <v-icon small>edit</v-icon>
                </v-btn>
                <span>Edit Staff</span>
              </v-tooltip>
              <v-tooltip top>
                <v-btn
                  icon
                  small
                  color="error"
                  :disabled="isEditStaff"
                  @click="deleteItem(props.item)"
                  slot="activator"
                >
                  <v-icon small>delete</v-icon>
                </v-btn>
                <span>Delete Staff</span>
              </v-tooltip>
            </div>
            <div v-else class="text-xs-center">
              <v-progress-circular
                size="20"
                width="2"
                color="primary"
                indeterminate
              ></v-progress-circular>
              <div class="caption mt-1">Updating...</div>
            </div>
          </td>
        </tr>
      </template>

      <template slot="no-data">
        <div class="no-data-state">
          <div v-if="loadingMessage" class="text-xs-center">
            <v-progress-circular
              :size="30"
              color="primary"
              indeterminate
            ></v-progress-circular>
            Loading data...
          </div>
          <div v-else class="text-xs-center">
            <v-icon size="64" color="grey lighten-2" class="my-4">
              person_off
            </v-icon>
            <div class="headline mb-2">No staff members found</div>
            <div class="subheading grey--text mb-4">
              {{ "No data available" }}
            </div>
            <v-btn
              v-if="userData.length == 0 && loadingMessage != 'black'"
              color="primary"
              @click="getData()"
            >
              <v-icon class="mr-2">refresh</v-icon>
              Reload Data
            </v-btn>
          </div>
        </div>
      </template>
    </v-data-table>

    <!-- Dialogs -->
    <newUserDialog
      :newUserDialog="dialog"
      @setDialog="dialog = $event"
    ></newUserDialog>

    <editUserDialog
      :selectedItem="selectedItem"
      :originalUser="originalUser"
      :editDialog="editDialog"
      @setDialog="editDialog = $event"
      @setOriginal="originalUser = $event"
    ></editUserDialog>

    <addressList
      :selectedCustomer="selectedCustomer"
      :dialog="addressListDialog"
      @setDialog="addressListDialog = $event"
      @cancel="cancelEdit()"
    />

    <!-- Snackbar -->
    <v-snackbar
      v-model="errSnackbar"
      color="error"
      :timeout="4000"
      bottom
      right
    >
      <v-icon color="white" class="mr-2">error</v-icon>
      {{ snackBarMsg || "Something went wrong!" }}
      <v-btn flat color="white" @click="errSnackbar = false"> Close </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import newUserDialog from "./NewUser";
import editUserDialog from "./EditUser.vue";
import addressList from "@/components/back-office/CustomerManagement/AddressList.vue";
export default {
  data: () => ({
    search: "",
    loadingMessage: false,
    pagination: {
      rowsPerPage: 10,
    },
    addressListDialog: false,
    fetching_address: null,
    selectedItem: null,
    dialog: false,
    editDialog: false,
    selectedCustomer: null,
    originalUser: null,
    headers: [
      {
        text: "Country",
        value: "user_country_tel",
        align: "center",
        sortable: false,
        width: "100px",
      },
      {
        text: "Phone Number",
        align: "center",
        value: "user_tel",
        sortable: false,
      },
      {
        text: "Email Address",
        align: "center",
        value: "user_email",
        sortable: false,
      },
      {
        text: "Staff Member",
        align: "center",
        value: "user_full_name_temp",
        sortable: false,
      },
      {
        text: "Role",
        align: "center",
        value: "user_role_name_temp",
        sortable: false,
      },
      {
        text: "Account Type",
        value: "user_type_name_temp",
        align: "center",
        sortable: false,
      },
      {
        text: "Address",
        align: "center",
        sortable: false,
        width: "120px",
      },
      {
        text: "VIP Status",
        align: "center",
        value: "user_vip",
        sortable: false,
        width: "100px",
      },
      {
        text: "Actions",
        align: "center",
        sortable: false,
        width: "120px",
      },
    ],
    editedIndex: null,
    alreadyCheckOTP: false,
    errSnackbar: false,
    snackBarMsg: null,
  }),
  components: {
    newUserDialog,
    addressList,
    editUserDialog,
  },
  computed: {
    ...mapState({
      indexEditLoading: (state) => state.fetchUserBack.indexEditLoading,
      userData: (state) => state.fetchUserBack.userData,
    }),
    ...mapGetters(["isEditStaff"]),
    pages() {
      this.pagination.totalItems = this.filterdUserData.length;
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    filterdUserData() {
      const filtered = this.userData.filter((val) => {
        return val.user_role != 6;
      });

      return filtered;
    },
  },
  methods: {
    ...mapActions({
      setUserToVIP: "fetchUserBack/setUserToVIP",
    }),
    cancelEdit() {
      this.selectedCustomer = null;
    },
    async editAddress(item) {
      this.selectedCustomer = item;
      this.fetching_address = item.user_id;
      this.selectedCustomer.user_address = await this.$store.dispatch(
        "fetchCustomerBack/getCustomerAddressDetail",
        item.user_id
      );

      this.fetching_address = null;
      this.addressListDialog = true;
      this.$store.dispatch("fetchCustomerBack/getProvinceAdd");
    },
    nameCheck(item) {
      item.user_full_name_temp =
        item.user_first_name + " " + item.user_last_name;
      return item.user_full_name_temp;
    },
    typeCheck(checkData) {
      if (checkData.user_type == "1") {
        checkData.user_type_name_temp = "Weserve";
      } else if (checkData.user_type == "2") {
        checkData.user_type_name_temp = "Facebook";
      }
      return checkData.user_type_name_temp;
    },
    roleCheck(checkData) {
      if (checkData.user_role == "1") {
        checkData.user_role_name_temp = "SuperAdmin";
      } else if (checkData.user_role == "2") {
        checkData.user_role_name_temp = "Admin";
      } else if (checkData.user_role == "3") {
        checkData.user_role_name_temp = "Viewer(Manager)";
      } else if (checkData.user_role == "4") {
        checkData.user_role_name_temp = "Callcenter";
      } else if (checkData.user_role == "6") {
        checkData.user_role_name_temp = "Customer";
      } else if (checkData.user_role == "7") {
        checkData.user_role_name_temp = "Store owner";
      } else if (checkData.user_role == "8") {
        checkData.user_role_name_temp = "RiderManager";
      } else if (checkData.user_role == "9") {
        checkData.user_role_name_temp = "Accounting";
      } else if (checkData.user_role == "10") {
        checkData.user_role_name_temp = "Marketing";
      } else if (checkData.user_role == "11") {
        checkData.user_role_name_temp = "AdminLaborStore";
      } else if (checkData.user_role == "13") {
        checkData.user_role_name_temp = "CallCenterAdmin";
      } else {
        checkData.user_role_name_temp = "Other";
      }
      return checkData.user_role_name_temp;
    },
    editItem(item) {
      this.editedIndex = this.userData.indexOf(item);
      this.selectedItem = item;
      this.originalUser = Object.assign({}, item);
      this.editDialog = true;
    },

    deleteItem(item) {
      const index = this.userData.indexOf(item);
      confirm(
        "Are you sure you want to delete this user ? \n* this user will change to customer."
      ) && this.$store.dispatch("fetchUserBack/deleteUser", item);
    },
    async getData() {
      this.loadingMessage = true;
      await this.$store.dispatch("fetchUserBack/getData");
      this.loadingMessage = false;
    },
    async setVIP(value, item) {
      let result = await this.setUserToVIP({
        user_id: item.user_id,
        user_level_status: value.status,
        otp_pin: value.otp_pin,
        otp_ref: value.otp_ref,
        otp_tel: value.otp_tel,
      });
      if (result === false || result.msg == false) {
        item.user_vip = !item.user_vip;
        this.errSnackbar = true;
        this.snackBarMsg = result.data;
      }
    },
    getRoleColor(role) {
      const roleColors = {
        1: "red darken-2", // SuperAdmin
        2: "orange darken-2", // Admin
        3: "blue darken-2", // Viewer
        4: "green darken-2", // Callcenter
        7: "purple darken-2", // Store owner
        8: "indigo darken-2", // RiderManager
        9: "teal darken-2", // Accounting
        10: "pink darken-2", // Marketing
        11: "brown darken-2", // AdminLaborStore
        13: "cyan darken-2", // CallCenterAdmin
      };
      return roleColors[role] || "grey darken-2";
    },
    getRoleTextColor(role) {
      return "white";
    },
    getTypeColor(type) {
      return type == "1" ? "#fddf00" : "#1877F2";
    },
    getTypeIcon(type) {
      return type == "1" ? "web" : "facebook";
    },
    getTypeTextColor(type) {
      return type == "1" ? "black" : "white";
    },
    getAddressButtonColor() {
      return "grey lighten-1";
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped>
.search-field {
  max-width: 100%;
  width: 100%;
}

.add-user-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 600;
  color: black;
}

.modern-table {
  border-radius: 12px;
  overflow: hidden;
}

.table-row:hover {
  background-color: #f5f5f5;
}

.country-code {
  font-family: monospace;
  font-weight: 600;
}

.role-chip {
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.type-chip {
  border-radius: 16px;
}

.type-chip-modern {
  border-radius: 20px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
  border: none !important;
  padding: 8px 12px !important;
  height: auto !important;
}

.type-chip-modern .v-chip__content {
  display: flex !important;
  align-items: center !important;
}

.address-btn-modern {
  border-radius: 25px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  padding: 8px 16px !important;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2) !important;
  transition: all 0.3s ease !important;
  background: linear-gradient(45deg, #78909c 0%, #90a4ae 100%) !important;
  color: white !important;
  border: 2px solid transparent !important;
}

.address-btn-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3) !important;
  background: linear-gradient(45deg, #607d8b 0%, #78909c 100%) !important;
}

.address-btn-modern:active {
  transform: translateY(0) !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2) !important;
}

.address-btn-modern .v-btn__content {
  display: flex !important;
  align-items: center !important;
}

.vip-checkbox {
  margin: 0;
  padding: 0;
}

.type-badge-enhanced {
  border-radius: 30px !important;
  font-weight: 700 !important;
  text-transform: capitalize !important;
  letter-spacing: 0.8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
  border: 2px solid rgba(255, 255, 255, 0.3) !important;
  padding: 6px 16px !important;
  height: 32px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
  overflow: hidden !important;
}

.type-badge-enhanced:hover {
  transform: translateY(-2px) scale(1.05) !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3) !important;
}

.type-badge-enhanced:before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  transition: left 0.6s;
}

.type-badge-enhanced:hover:before {
  left: 100%;
}

.type-badge-enhanced .v-chip__content {
  display: flex !important;
  align-items: center !important;
  font-size: 0.75rem !important;
  z-index: 1;
  position: relative;
}

.type-avatar {
  background: rgba(255, 255, 255, 0.2) !important;
  width: 20px !important;
  height: 20px !important;
  margin-right: 8px !important;
  margin-left: -4px !important;
}

.type-avatar .v-icon {
  font-size: 12px !important;
  color: white !important;
}

.no-type-text {
  color: #bdbdbd;
  font-style: italic;
  font-weight: 500;
}

/* Facebook specific styling */
.type-badge-enhanced[style*="#1877F2"] {
  background: linear-gradient(135deg, #1877f2 0%, #42a5f5 100%) !important;
}

/* Weserve specific styling */
.type-badge-enhanced[style*="#fddf00"] {
  background: linear-gradient(135deg, #fddf00 0%, #fff176 100%) !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .add-user-btn {
    margin-top: 12px;
  }

  .stat-card {
    margin-bottom: 12px;
  }
}
</style>